import { apiRequest } from '@/lib/api-client';

export interface User {
  id: number;
  email: string;
  is_admin: boolean;
  created_at: string;
}

export const getAllUsers = async (): Promise<User[]> => {
  return apiRequest<User[]>('/users');
};

export const getUser = async (id: number): Promise<User> => {
  return apiRequest<User>(`/users/${id}`);
};

export const createUser = async (data: Partial<User> & { password?: string }): Promise<User> => {
  return apiRequest<User>('/users', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const updateUser = async (id: number, data: Partial<User> & { password?: string }): Promise<User> => {
  return apiRequest<User>(`/users/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

export const deleteUser = async (id: number): Promise<void> => {
  await apiRequest(`/users/${id}`, {
    method: 'DELETE',
  });
};
